/**
 * @type {{
*  GoogleMap: String,
*  reCAPTCHA: String
* }}
*/
export const APIKeys = {
 GoogleMap: "AIzaSyBntciTfOVVsP8R47sDOUwYg8mR3c_qIgg",
 reCAPTCHA: "6LcAie8pAAAAAKOY2-__9Mvq2dAitRUGI7IL6G9I"
};